import initalizeMap from '../directoyMap';

export default function init()
{
    updateListingDisplay(1);

    attachPaginationEventListeners();

    const directoryContainer = document.querySelector('.security-systems-listings .cards-container');
    const loadingDiv = document.querySelector('.loading-listings');
    const paginationContainer = document.querySelector('.pagination');

    function updateListingDisplay(currentPage) 
    {
        const defaultListingsPerPage = 25;
        const firstPageLimit = parseInt(window.directory_settings?.first_per_page_limit) || defaultListingsPerPage;

        const showingIndicatorElement = document.getElementById('showing-indicator');
        const totalPropertiesElement = document.getElementById('total-properties');

        if (!showingIndicatorElement || !totalPropertiesElement) {
            return;
        }

        const totalProperties = parseInt(totalPropertiesElement.textContent);
        if (isNaN(totalProperties) || totalProperties < 0) {
            showingIndicatorElement.textContent = '0';
            return;
        }

        let startListing;
        let endListing;

        if (currentPage === 1) {
            startListing = 1;
            endListing = firstPageLimit;
        } else {
            const itemsBeforeCurrentPage = firstPageLimit + (currentPage - 2) * defaultListingsPerPage;
            startListing = itemsBeforeCurrentPage + 1;
            endListing = itemsBeforeCurrentPage + defaultListingsPerPage;
        }

        if (endListing > totalProperties) {
            endListing = totalProperties;
        }

        showingIndicatorElement.textContent = `${startListing}-${endListing}`;
    }

    function attachPaginationEventListeners()
    {
        document.querySelectorAll('.pagination .page-link').forEach(link => {
            const pageItem = link.closest('.page-item');

            link.removeEventListener('click', handlePaginationClick);
            if (pageItem.classList.contains('active')) {
                link.style.pointerEvents = 'none';
                link.style.cursor = 'default';
            } else {
                if (link.tagName === 'A' && !pageItem.classList.contains('inactive')) {
                    link.addEventListener('click', handlePaginationClick);
                    link.style.pointerEvents = 'auto';
                    link.style.cursor = 'pointer';
                }
            }
        });
    }

    function handlePaginationClick(event)
    {
        event.preventDefault();
        const page = this.getAttribute('data-page');
        if (!page) {
            return;
        }
        fetchPaginatedData(page);
    }

    function fetchPaginatedData(page)
    {
        const url = new URL(window.location.href);
        const urlParams = new URLSearchParams(url.search);

        urlParams.set('page', page);

        const fetchUrl = `${url.pathname}?${urlParams.toString()}`;
        showLoadingState();

        fetch(fetchUrl, {
            method: 'GET',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })
            .then(response => response.json())
            .then(data => {
                let properties = Array.isArray(data.properties) ? data.properties : [];

                // If it's page 1, limit the number of properties shown
                if (properties.length && page === '1') {
                    properties = properties.slice(0, window.directory_settings.first_per_page_limit);
                }

                updateListings(properties);
                updatePagination(data.pagination);

                updateListingDisplay(page);

                window.shPropertyAddress = properties;
                initalizeMap();

                setTimeout(() => {
                    const element = document.querySelector('.security-systems-listings');
                    if (element) {
                        const elementTop = element.offsetTop;
                        const offset = 50; // 50 pixels higher
                        window.scrollTo({
                            top: elementTop - offset,
                            behavior: 'smooth',
                        });
                    }
                }, 50);
            })
            .catch(error => {
                console.error('Error fetching paginated data:', error);
            })
            .finally(() => {
                hideLoadingState();
            });
    }

    function showLoadingState()
    {
        if (!directoryContainer || !loadingDiv) {
            return;
        }
        directoryContainer.style.opacity = '0.3';
        loadingDiv.style.display = 'block';
        loadingDiv.innerHTML = '<span class="loading-text">Loading Listings...</span>';
    }

    function hideLoadingState()
    {
        if (directoryContainer) {
            directoryContainer.style.opacity = '1';
        }
        if (loadingDiv) {
            loadingDiv.style.display = 'none';
            loadingDiv.innerHTML = '';
        }
    }

    function updateListings(properties)
    {
        if (!directoryContainer) {
            return;
        }

        directoryContainer.innerHTML = '';

        const template = document.querySelector('#listing-template');

        if (!template) {
            return;
        }

        properties.forEach((listing) => {
            const listingElement = template.content.cloneNode(true);

            // listingElement.querySelector('.listing-image').innerHTML = listing.image;
            listingElement.querySelector('.listing-title').textContent = listing.name;
            listingElement.querySelector('.listing-address').innerHTML = listing.address;

            const categoryElement = listingElement.querySelector('.category-wrapper');
            if (listing.categories && listing.categories.length) {
                listing.categories.forEach(cat => {
                    const categoryPill = document.createElement('span');
                    categoryPill.classList.add('cat-pills');
                    categoryPill.textContent = cat.name;
                    categoryElement.appendChild(categoryPill);
                });
            }

            // Handle summary with new structure
            const summaryElement = listingElement.querySelector('.listing-summary');
            if (summaryElement && listing.summary) {
                const summarySpan = summaryElement.querySelector('.summary');
                const moreLink = summaryElement.querySelector('.summary-more');
                const lessLink = summaryElement.querySelector('.summary-less');

                if (summarySpan) {
                    summarySpan.textContent = listing.summary.full_summary || '';

                    // For desktop, don't show more/less links initially
                    // The SummaryHandler will handle responsive behavior
                    if (moreLink) moreLink.style.display = 'none';
                    if (lessLink) lessLink.style.display = 'none';
                }
            }

            if (listing.score) {
                listingElement.querySelector('.listing-card__score-value').innerHTML = listing.score;
            }

            directoryContainer.appendChild(listingElement);
        });

        // Process summaries for new content
        if (window.listingsSummaryHandler) {
            window.listingsSummaryHandler.processNewContent(directoryContainer);
        }
    }

    function updatePagination(pagination)
    {
        if (!paginationContainer) {
            console.log('No pagination container found');
            return;
        }

        console.log('Updating pagination with data:', pagination);

        let paginationHtml = '<ul class="pag-background">';

        paginationHtml += `
            <li class="page-item prev ${pagination.prev ? '' : 'inactive'}"">
                <a class="page-link" data-link-type="on-page" data-elementplacement="listing-pagination" data-elementclicked="previous" data-direction="back" data-page="${pagination.current_page - 1}">Prev</a>
            </li>
        `;

        pagination.links.forEach(link => {
            paginationHtml += `<li class="page-item ${link.is_active ? 'active' : ''}">`;
            if (link.page === null) {
                paginationHtml += `<span class="filler-link">${link.label}</span>`;
            } else {
                paginationHtml += `<a class="page-link" data-link-type="on-page" data-elementplacement="listing-pagination" data-elementclicked="numeric" data-page="${link.page}">${link.label}</a>`;
            }
            paginationHtml += '</li>';
        });

        paginationHtml += `
            <li class="page-item next ${pagination.next ? '' : 'inactive'}">
                <a class="page-link" data-link-type="on-page" data-elementplacement="listing-pagination" data-elementclicked="next" data-direction="forward" data-page="${pagination.current_page + 1}">Next</a>
            </li>
        `;

        paginationHtml += '</ul>';

        paginationContainer.innerHTML = paginationHtml;

        attachPaginationEventListeners();
    }
}
